import { useRoute } from '@react-navigation/native'
import { Stack, XStack } from '@zet/design-system/layout'

import { GoBackButton } from '../../components/GoBackButton'
import { useNavigation } from '../../hooks/useNavigation'

export default function StackHeader({
  closeButton = false,
  showBackButton = false,
  isAddCustomerFlow = false,
}) {
  const navigation = useNavigation()
  const { params = {} } = useRoute()

  return (
    <XStack
      style={{
        backgroundColor: '#fff',
      }}
    >
      {showBackButton || navigation.canGoBack() || params?.isDemoSale ? (
        <Stack className="p-2">
          <GoBackButton
            isAddCustomerFlow={isAddCustomerFlow}
            className="ml-1 mr-3 mt-1 h-5 w-5 items-center justify-center rounded bg-[#F5F7FB]"
            color="#050505"
            isDemoSale={params?.isDemoSale}
          />
        </Stack>
      ) : null}
    </XStack>
  )
}
